// extracted by mini-css-extract-plugin
export var aiStarIcon = "_7c-4";
export var closeButton = "_7c-6";
export var dismissButton = "_7c-3";
export var editImageWithAiContainer = "_7c-8";
export var imageUploadWrapper = "_7c-7";
export var misspelledWord = "_7c-5";
export var spellCheckContainer = "_7c-2";
export var spin = "_7c-1";
export var spinning = "_7c-0";